import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { LayoutComponent } from './containers/default-layout/layout.component';
import { AuthenticationGuard } from './@shared/guards/authentication.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
          canActivate: mapToCanActivate([AuthenticationGuard])
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./views/users/user.module').then((m) => m.UserModule),
          canActivate: mapToCanActivate([AuthenticationGuard])
      },
      {
        path: 'marketing',
        loadChildren: () =>
          import('./views/marketing-page/marketing.module').then((m) => m.MarketingModule),
          canActivate: mapToCanActivate([AuthenticationGuard])
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./views/settings/settings.module').then((m) => m.SettingsModule),
          canActivate: mapToCanActivate([AuthenticationGuard])
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./views/clients/clients.module').then((m) => m.ClientsModule),
          canActivate: mapToCanActivate([AuthenticationGuard])
      },
      {
        path: 'streaming',
        loadChildren: () =>
          import('./views/streaming/streaming.module').then((m) => m.StreamingModule),
          canActivate: mapToCanActivate([AuthenticationGuard])
      },
      {
        path: 'agents',
        loadChildren: () =>
          import('./views/agents/agents.module').then((m) => m.AgentsModule),
          canActivate: mapToCanActivate([AuthenticationGuard])
      }
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page',
    },
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      // relativeLinkResolution: 'legacy'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
